import { render, staticRenderFns } from "./sidebarDetailImageRating.vue?vue&type=template&id=440ff717&scoped=true"
import script from "./sidebarDetailImageRating.vue?vue&type=script&lang=js"
export * from "./sidebarDetailImageRating.vue?vue&type=script&lang=js"
import style0 from "./sidebarDetailImageRating.vue?vue&type=style&index=0&id=440ff717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ff717",
  null
  
)

export default component.exports